import React from 'react';
import { Link } from 'react-router-dom';

const Suggestions = ({ results }) => {
  let options;
  if (results) {
    options = results.slice(0, 6).map(el => (
      <Link
        className="suggestions-link"
        to={`/${el.type.toLowerCase()}/${el.id}`}
        key={el.id}>
        <div className="suggestions-container">
          <img
            src={el.typeAheadImg}
            alt={el.title}
            className="suggestions-img"
          />
          <div className="suggestions-wrapper">
            <p className="suggestions-wrapper__year">Year: {el.year}</p>
            <p className="suggestions-wrapper__rating">Rating: {el.rating}</p>
            <p className="suggestions-wrapper__title">Title: {el.title}</p>
          </div>
        </div>
      </Link>
    ));
  } else {
    options = '';
  }

  return <div className="suggestions">{options}</div>;
};

export default Suggestions;
